(function () {
    'use strict';

    commonModule.factory('locationService', ['$http', 'AppSettings', 'TLCError','AppErrorCodes',
        function ($http, AppSettings, TLCError,AppErrorCodes) {

            function getLocationInfoFromZipCode(zipCode) {
                var URL = new URI('https://www.zipcodeapi.com/').segment(['rest', AppSettings.zipCodeApiKey, 'info.json', zipCode, 'radians']).toString();;

                return $http({
                    method: 'GET',
                    url: URL,
                    headers: {
                        'cache-control': undefined,
                        'pragma': undefined
                    }
                })
                    .then(function(response){
                        return _.pick(response.data, 'city', 'state');
                    })
                    .catch(function(err) {
                        throw new TLCError(new Error(err.data.error_msg), AppErrorCodes.ZipService_Error);
                    });
            }

            return {
                getLocationInfoFromZipCode: getLocationInfoFromZipCode
            };
        }]);
})();
